<ng-template #contentGuide let-modal>
  <div class="modal-header border-0 pb-0 position-relative">
    <button type="button" class="btn-close ms-auto" aria-label="Fermer" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body px-md-5 pb-5 pt-0">
    <div class="text-center mb-4">
      <div class="mb-3">
        <span class="badge bg-gold text-dark fs-6 px-3 py-2 rounded-pill shadow-sm">
          <i class="bi bi-book-half me-1"></i> Ebook Offert
        </span>
      </div>
      <h3 class="fw-bold text-bleu-tdm text-uppercase mb-2">
        Télécharger {{ guideTitle }}
      </h3>
      <p class="text-secondary fs-6">
        ⚡ <strong>Boostez votre projet immobilier avec nos secrets d'experts !</strong><br>
        Recevez gratuitement votre guide complet et bénéficiez d'un accompagnement personnalisé pour réussir votre projet en toute sérénité.
      </p>
    </div>

    <form [formGroup]="guideForm" (ngSubmit)="onSubmit()" novalidate>
      <div class="row g-3">
        <!-- Prénom -->
        <div class="col-md-6">
          <label for="prenom" class="form-label fw-semibold">Prénom <span class="text-danger">*</span></label>
          <input
            type="text"
            id="prenom"
            formControlName="prenom"
            class="form-control form-control-lg"
            placeholder="Ex : Jean"
            [ngClass]="{ 'is-invalid': (submitted || f['prenom'].touched) && f['prenom'].errors, 'is-valid': f['prenom'].valid && f['prenom'].touched }"
          />
          <div *ngIf="(submitted || f['prenom'].touched) && f['prenom'].errors" class="invalid-feedback">
            Veuillez saisir un prénom valide.
          </div>
        </div>

        <!-- Nom -->
        <div class="col-md-6">
          <label for="nom" class="form-label fw-semibold">Nom <span class="text-danger">*</span></label>
          <input
            type="text"
            id="nom"
            formControlName="nom"
            class="form-control form-control-lg"
            placeholder="Ex : Dupont"
            [ngClass]="{ 'is-invalid': (submitted || f['nom'].touched) && f['nom'].errors, 'is-valid': f['nom'].valid && f['nom'].touched }"
          />
          <div *ngIf="(submitted || f['nom'].touched) && f['nom'].errors" class="invalid-feedback">
            Veuillez saisir un nom valide.
          </div>
        </div>

        <!-- Email -->
        <div class="col-12">
          <label for="email" class="form-label fw-semibold">Adresse Email <span class="text-danger">*</span></label>
          <input
            type="email"
            id="email"
            formControlName="email"
            class="form-control form-control-lg"
            placeholder="Ex : jean.dupont@email.fr"
            [ngClass]="{ 'is-invalid': (submitted || f['email'].touched) && f['email'].errors, 'is-valid': f['email'].valid && f['email'].touched }"
          />
          <div *ngIf="(submitted || f['email'].touched) && f['email'].errors" class="invalid-feedback">
            Veuillez saisir une adresse e-mail valide.
          </div>
        </div>

        <!-- Code Postal -->
        <div class="col-md-6">
          <label for="codePostal" class="form-label fw-semibold">Code Postal <span class="text-danger">*</span></label>
          <input
            type="text"
            id="codePostal"
            formControlName="codePostal"
            maxlength="5"
            class="form-control form-control-lg"
            placeholder="Ex : 75008"
            [ngClass]="{ 'is-invalid': (submitted || f['codePostal'].touched) && f['codePostal'].errors, 'is-valid': f['codePostal'].valid && f['codePostal'].touched }"
          />
          <div *ngIf="(submitted || f['codePostal'].touched) && f['codePostal'].errors" class="invalid-feedback">
            Code postal à 5 chiffres (ex: 75008).
          </div>
        </div>

        <!-- Téléphone -->
        <div class="col-md-6">
          <label for="phone" class="form-label fw-semibold">Téléphone <span class="text-danger">*</span></label>
          <input
            type="tel"
            id="phone"
            formControlName="phone"
            maxlength="14"
            class="form-control form-control-lg"
            placeholder="Ex : 06 12 34 56 78"
            [ngClass]="{ 'is-invalid': (submitted || f['phone'].touched) && f['phone'].errors, 'is-valid': f['phone'].valid && f['phone'].touched }"
          />
          <div *ngIf="(submitted || f['phone'].touched) && f['phone'].errors" class="invalid-feedback">
            Numéro de téléphone valide (ex: 0612345678).
          </div>
        </div>
      </div>

      <div class="mt-4 text-center">
        <button
          type="submit"
          [disabled]="guideForm.invalid || loading"
          class="btn btn-gold btn-lg w-100 py-3 fw-bold shadow-sm"
        >
          <span *ngIf="loading" class="spinner-border spinner-border-sm me-2"></span>
          <i *ngIf="!loading" class="bi bi-download me-2"></i>
          Télécharger le guide
        </button>
        <small class="text-muted d-block mt-2">
          🔒 Vos données sont confidentielles et protégées.
        </small>
      </div>
    </form>
  </div>
</ng-template>
